import { combineReducers } from 'redux';
import searchConditionReducer from './searchCondition/reducer';
import layoutReducer from './layout/reducer';

export default combineReducers({
  searchCondition: searchConditionReducer,
  layout: layoutReducer,
});
